"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeCustomizer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var theme_1 = __importDefault(require("../theme"));
var leva_1 = require("leva");
var useLocalTheme_1 = require("./useLocalTheme");
var allowedKeys = [
    "font",
    "theme",
    "mode",
    "primaryColor",
    "dm__primaryColor",
    "dm__primaryColorOnLight",
    "secondaryColor",
    "dm__secondaryColor",
    "background",
    "dm__background",
    "cardBackgroundColor",
    "dm__cardBackgroundColor",
    "colorBackground",
    "dm__colorBackground",
    "textColor",
    "dm__textColor",
    "errorColor",
    "dm__errorColor",
    "invertColor",
    "inputBg",
    "dm__inputBg",
    "inputDisabledBg",
    "dm__inputDisabledBg",
    "labelListValueColor",
    "dm__labelListValueColor",
    "outlineButtonColor",
    "dm__outlineButtonInvertColor",
    "breadcrumbsColor",
    "dm__breadcrumbsColor",
    "primaryButtonDisabled",
    "dm__primaryButtonDisabled",
    "outlineButtonColor",
    "dm__outlineButtonColor",
    "outlineButtonInvertColor",
    "buttonRadius",
    "checkboxRadius",
    "inputRadius",
    "noteRadius",
    "cardRadius",
    "white",
    "gray5",
    "gray4",
    "gray3",
    "gray2",
    "gray1",
    "black",
];
var filterInputData = function (input) {
    return allowedKeys.reduce(function (acc, curr) {
        var _a;
        return typeof input[curr] !== "undefined"
            ? __assign(__assign({}, acc), (_a = {}, _a[curr] = input[curr], _a)) : acc;
    }, {});
};
var ThemeCustomizer = function (_a) {
    var onUpdate = _a.onUpdate, _b = _a.hasAll, hasAll = _b === void 0 ? false : _b, _c = _a.hidden, hidden = _c === void 0 ? false : _c, initialTheme = _a.initialTheme;
    var localTheme = (0, useLocalTheme_1.useLocalTheme)(initialTheme)[0];
    var initData = (0, react_1.useMemo)(function () {
        return filterInputData(localTheme);
    }, []);
    var _d = (0, leva_1.useControls)(function () {
        var _a, _b;
        return ({
            theme: {
                label: "Theme",
                value: hasAll
                    ? initData.theme ||
                        (Object.keys(theme_1.default).includes(window.location.hash.substr(1))
                            ? window.location.hash.substr(1)
                            : "all")
                    : initData.theme || Object.keys(theme_1.default)[0],
                options: hasAll
                    ? __spreadArray(__spreadArray(["all"], Object.keys(theme_1.default), true), ["custom"], false) : __spreadArray(__spreadArray([], Object.keys(theme_1.default), true), ["custom"], false),
                onChange: function (theme) {
                    switch (theme) {
                        case "all":
                        case "custom":
                            break;
                        default:
                            set(__assign({ theme: theme }, filterInputData(theme_1.default[theme])));
                    }
                },
                transient: false,
            },
            mode: {
                options: ["light", "dark"],
                value: initData.mode || "light",
            },
            Customize: (0, leva_1.folder)({
                font: {
                    options: ["Inter", "Mulish", "Titillium", "Lato"],
                    value: initData.font || "Inter",
                },
                "Main Colors": (0, leva_1.folder)({
                    primaryColor: initData.primaryColor || "#000000",
                    dm__primaryColor: initData.dm__primaryColor || "#000000",
                    dm__primaryColorOnLight: initData.dm__primaryColor || "#000000",
                    secondaryColor: initData.secondaryColor || "#000000",
                    dm__secondaryColor: initData.dm__secondaryColor || "#000000",
                    background: initData.background || "#000000",
                    dm__background: initData.dm__background || "#000000",
                    cardBackgroundColor: initData.cardBackgroundColor || "#000000",
                    dm__cardBackgroundColor: initData.dm__cardBackgroundColor || "#000000",
                    colorBackground: initData.colorBackground || "#000000",
                    dm__colorBackground: initData.dm__colorBackground || "#000000",
                    textColor: initData.textColor || "#000000",
                    dm__textColor: initData.dm__textColor || "#000000",
                    errorColor: initData.errorColor || "#EB5757",
                    dm__errorColor: initData.dm__errorColor || "#EB5757",
                    invertColor: initData.invertColor || "#000000",
                }),
                "Body Colors": (0, leva_1.folder)({
                    inputBg: initData.inputBg || "#f8f8f8",
                    dm__inputBg: initData.dm__inputBg || "#4a4a4a",
                    inputDisabledBg: initData.inputDisabledBg || "#1f1f1f",
                    dm__inputDisabledBg: initData.dm__inputDisabledBg || "#1f1f1f",
                    labelListValueColor: initData.labelListValueColor || "#000000",
                    dm__labelListValueColor: initData.dm__labelListValueColor || "#000000",
                    primaryButtonDisabled: initData.primaryButtonDisabled || "#000000",
                    dm__primaryButtonDisabled: (_b = (_a = initData.dm__primaryButtonDisabled) !== null && _a !== void 0 ? _a : initData.gray2) !== null && _b !== void 0 ? _b : "#555555",
                    outlineButtonColor: initData.outlineButtonColor || "#000000",
                    dm__outlineButtonColor: initData.dm__outlineButtonColor || "#ffffff",
                    outlineButtonInvertColor: initData.outlineButtonInvertColor || "#000000",
                    dm__outlineButtonInvertColor: initData.dm__outlineButtonInvertColor || "#000000",
                    breadcrumbsColor: initData.breadcrumbsColor || "#bbbbbb",
                    dm__breadcrumbsColor: initData.dm__breadcrumbsColor || "#ffffff",
                }),
                "Utility Colors": (0, leva_1.folder)({
                    white: initData.white || "#000000",
                    gray5: initData.gray5 || "#000000",
                    gray4: initData.gray4 || "#000000",
                    gray3: initData.gray3 || "#000000",
                    gray2: initData.gray2 || "#000000",
                    gray1: initData.gray1 || "#000000",
                    black: initData.black || "#000000",
                    inputDisabledBg: initData.inputDisabledBg || "#000000",
                    labelListValueColor: initData.labelListValueColor || "#000000",
                    primaryButtonDisabled: initData.primaryButtonDisabled || "#000000",
                    outlineButtonColor: initData.outlineButtonColor || "#000000",
                    outlineButtonInvertColor: initData.outlineButtonColor || "#000000",
                    breadcrumbsColor: initData.breadcrumbsColor || "#000000",
                    numerationsColor: initData.numerationsColor || "#000000",
                    dm__numerationsColor: initData.dm__numerationsColor || "#000000",
                }),
                Radiuses: (0, leva_1.folder)({
                    buttonRadius: {
                        min: 0,
                        max: 16,
                        step: 1,
                        value: initData.buttonRadius || 0,
                    },
                    checkboxRadius: {
                        min: 0,
                        max: 5,
                        step: 1,
                        value: initData.checkboxRadius || 0,
                    },
                    inputRadius: {
                        min: 0,
                        max: 16,
                        step: 1,
                        value: initData.inputRadius || 0,
                    },
                    cardRadius: {
                        min: 0,
                        max: 16,
                        step: 1,
                        value: initData.cardRadius || 0,
                    },
                }),
            }, {
                render: function (get) { return get("theme") === "custom"; },
            }),
        });
    }), props = _d[0], set = _d[1];
    (0, react_1.useEffect)(function () {
        onUpdate(props);
    }, [props]);
    return (0, jsx_runtime_1.jsx)(leva_1.Leva, { hidden: hidden });
};
exports.ThemeCustomizer = ThemeCustomizer;
exports.default = exports.ThemeCustomizer;
